import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMode } from '../contexts/ModeContext';

const ModeToggle: React.FC = () => {
  const { mode, setMode, canToggleMode } = useMode();
  const navigate = useNavigate();

  const handleClick = () => {
    if (!canToggleMode) return;

    const newMode = mode === 'student' ? 'admin' : 'student';
    setMode(newMode);

    // Navigate to appropriate page based on mode
    if (newMode === 'admin') {
      navigate('/admin/exercises');
    } else {
      navigate('/dashboard');
    }
  };

  const displayMode = mode === 'admin' ? 'Admin' : 'Student';

  return (
    <button
      onClick={handleClick}
      disabled={!canToggleMode}
      className={`
        px-4 py-2 rounded-full text-sm font-semibold transition-all duration-200
        ${
          mode === 'admin'
            ? 'bg-hexagon text-white shadow-lg'
            : 'bg-gray-200 text-gray-700'
        }
        ${
          canToggleMode
            ? 'cursor-pointer hover:opacity-90 hover:shadow-md'
            : 'cursor-default opacity-75'
        }
        focus:outline-none focus:ring-2 focus:ring-hexagon focus:ring-offset-2
      `}
      aria-label={
        canToggleMode
          ? `Switch to ${mode === 'student' ? 'admin' : 'student'} mode`
          : 'Student mode (admin access required to switch)'
      }
    >
      {displayMode}
    </button>
  );
};

export default ModeToggle;
